exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-menu {\r\n  max-height: 300px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.label-required {\r\n  float: right;\r\n  color: #ff442a;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/common/specializations/components/add-new-group/add-new-group.component.css
// module id = ../../../../../src/app/content-page/common/specializations/components/add-new-group/add-new-group.component.css
// module chunks = main